var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6722 78.2619C77.0957 78.2618 76.5429 78.0327 76.1353 77.625L41.3527 42.8424C40.9567 42.4324 40.7376 41.8832 40.7425 41.3132C40.7475 40.7432 40.9761 40.198 41.3792 39.7949C41.7822 39.3919 42.3275 39.1632 42.8975 39.1583C43.4674 39.1533 44.0166 39.3725 44.4266 39.7684L79.2092 74.551C79.5131 74.8551 79.7201 75.2424 79.8039 75.664C79.8878 76.0857 79.8447 76.5227 79.6802 76.9199C79.5157 77.317 79.2372 77.6565 78.8798 77.8954C78.5223 78.1343 78.1021 78.2618 77.6722 78.2619Z",
    fill: "url(#paint0_linear_16_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9342 100.001C60.7367 100.001 64.6298 96.1075 64.6298 91.305C64.6298 86.5026 60.7367 82.6094 55.9342 82.6094C51.1317 82.6094 47.2385 86.5026 47.2385 91.305C47.2385 96.1075 51.1317 100.001 55.9342 100.001Z",
    fill: "url(#paint1_linear_16_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7169 100.001C95.5194 100.001 99.4125 96.1075 99.4125 91.305C99.4125 86.5026 95.5194 82.6094 90.7169 82.6094C85.9144 82.6094 82.0212 86.5026 82.0212 91.305C82.0212 96.1075 85.9144 100.001 90.7169 100.001Z",
    fill: "url(#paint2_linear_16_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.369 34.7819C91.1715 34.7819 95.0646 30.8888 95.0646 26.0863C95.0646 21.2838 91.1715 17.3906 86.369 17.3906C81.5665 17.3906 77.6733 21.2838 77.6733 26.0863C77.6733 30.8888 81.5665 34.7819 86.369 34.7819Z",
    fill: "url(#paint3_linear_16_129)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_16_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.3256 41.3059H53.7603C53.1838 41.3059 52.6308 41.0769 52.2231 40.6692C51.8155 40.2615 51.5864 39.7086 51.5864 39.132C51.5864 38.5554 51.8155 38.0025 52.2231 37.5948C52.6308 37.1871 53.1838 36.9581 53.7603 36.9581H72.4256L82.6582 26.7255C83.0682 26.3295 83.6173 26.1104 84.1873 26.1153C84.7573 26.1203 85.3025 26.3489 85.7056 26.752C86.1087 27.155 86.3373 27.7003 86.3422 28.2703C86.3472 28.8403 86.1281 29.3894 85.7321 29.7994L74.8625 40.669C74.4549 41.0767 73.9021 41.3058 73.3256 41.3059Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.4256 38.1581H72.9226L73.2741 37.8066L83.4978 27.5828C83.6809 27.4091 83.9243 27.3131 84.1769 27.3153C84.4322 27.3175 84.6765 27.4199 84.8571 27.6005C85.0376 27.7811 85.1401 28.0253 85.1423 28.2807C85.1445 28.5333 85.0485 28.7767 84.8747 28.9597L74.014 39.8204L74.0139 39.8206C73.8313 40.0031 73.5837 40.1058 73.3256 40.1059C73.3255 40.1059 73.3254 40.1059 73.3253 40.1059H53.7603C53.502 40.1059 53.2543 40.0033 53.0717 39.8207C52.889 39.638 52.7864 39.3903 52.7864 39.132C52.7864 38.8737 52.889 38.626 53.0717 38.4433C53.2543 38.2607 53.502 38.1581 53.7603 38.1581H72.4256Z",
    stroke: "url(#paint4_linear_16_129)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_16_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.7169 86.9561C90.1404 86.9561 89.5874 86.7271 89.1797 86.3194C88.772 85.9117 88.543 85.3587 88.543 84.7822V76.9865L76.7734 65.217H71.1517C70.5751 65.217 70.0222 64.9879 69.6145 64.5802C69.2068 64.1726 68.9778 63.6196 68.9778 63.0431C68.9778 62.4665 69.2068 61.9136 69.6145 61.5059C70.0222 61.0982 70.5751 60.8691 71.1517 60.8691H77.6734C78.2499 60.8693 78.8028 61.0984 79.2104 61.5061L92.2539 74.5496C92.6616 74.9572 92.8907 75.51 92.8908 76.0865V84.7822C92.8908 85.3587 92.6618 85.9117 92.2541 86.3194C91.8464 86.7271 91.2935 86.9561 90.7169 86.9561Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.743 76.9865V76.4895L89.3915 76.138L77.622 64.3684L77.2705 64.017H76.7734H71.1517C70.8934 64.017 70.6457 63.9144 70.463 63.7317C70.2804 63.5491 70.1778 63.3014 70.1778 63.0431C70.1778 62.7848 70.2804 62.537 70.463 62.3544C70.6457 62.1717 70.8934 62.0691 71.1517 62.0691H77.6732C77.6733 62.0691 77.6733 62.0691 77.6734 62.0691C77.9316 62.0693 78.1792 62.1719 78.3617 62.3545L78.3619 62.3546L91.4053 75.3981L91.4055 75.3982C91.5881 75.5808 91.6907 75.8283 91.6908 76.0865C91.6908 76.0866 91.6908 76.0867 91.6908 76.0868L91.6908 84.7822C91.6908 85.0405 91.5882 85.2882 91.4056 85.4708C91.2229 85.6535 90.9752 85.7561 90.7169 85.7561C90.4586 85.7561 90.2109 85.6535 90.0282 85.4708C89.8456 85.2882 89.743 85.0405 89.743 84.7822V76.9865Z",
    stroke: "url(#paint5_linear_16_129)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_16_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3234 88.8674C50.7469 88.8673 50.194 88.6381 49.7864 88.2304L39.1799 77.6239C38.7722 77.2163 38.5431 76.6635 38.543 76.087V52.1739C38.543 51.5974 38.772 51.0444 39.1797 50.6367C39.5874 50.229 40.1403 50 40.7169 50C41.2934 50 41.8464 50.229 42.2541 50.6367C42.6618 51.0444 42.8908 51.5974 42.8908 52.1739V75.1869L52.8604 85.1565C53.1643 85.4605 53.3713 85.8478 53.4551 86.2695C53.5389 86.6911 53.4959 87.1282 53.3314 87.5253C53.1669 87.9225 52.8883 88.262 52.5309 88.5009C52.1735 88.7397 51.7533 88.8673 51.3234 88.8674Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.635 87.3819L50.6351 87.382C50.8176 87.5646 51.0651 87.6672 51.3231 87.6674L50.635 87.3819ZM50.635 87.3819L40.0285 76.7754L40.0283 76.7753M50.635 87.3819L40.0283 76.7753M40.0283 76.7753C39.8457 76.5927 39.7431 76.3451 39.743 76.087C39.743 76.0869 39.743 76.0868 39.743 76.0867V52.1739C39.743 51.9156 39.8456 51.6679 40.0282 51.4853C40.2109 51.3026 40.4586 51.2 40.7169 51.2C40.9752 51.2 41.2229 51.3026 41.4055 51.4853C41.5882 51.6679 41.6908 51.9156 41.6908 52.1739V75.1869V75.684M40.0283 76.7753L41.6908 75.684M41.6908 75.684L42.0423 76.0355M41.6908 75.684L42.0423 76.0355M42.0423 76.0355L52.0117 86.0049M42.0423 76.0355L52.0117 86.0049M52.0117 86.0049C52.1479 86.1411 52.2406 86.3146 52.2781 86.5035C52.3157 86.6924 52.2964 86.8882 52.2227 87.0661C52.149 87.2441 52.0242 87.3962 51.8641 87.5032C51.7041 87.6101 51.5161 87.6672 51.3237 87.6674L52.0117 86.0049Z",
    stroke: "url(#paint6_linear_16_129)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bi_16_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2103 61.5065L74.8625 57.1587C74.4549 56.751 73.9021 56.5219 73.3256 56.5217H68.9777C68.4012 56.5217 67.8482 56.2927 67.4405 55.885C67.0329 55.4773 66.8038 54.9244 66.8038 54.3478V50C66.8037 49.4235 66.5746 48.8706 66.1669 48.463L48.4082 30.7044C49.0723 28.5017 49.4106 26.2137 49.4125 23.9131C49.4125 19.1835 48.01 14.5602 45.3824 10.6277C42.7548 6.6952 39.0201 3.6302 34.6506 1.82028C30.2811 0.0103612 25.4729 -0.463197 20.8343 0.459493C16.1956 1.38218 11.9347 3.65968 8.5904 7.00398C5.24611 10.3483 2.96861 14.6092 2.04592 19.2478C1.12323 23.8865 1.59679 28.6946 3.40671 33.0642C5.21663 37.4337 8.28162 41.1684 12.2141 43.796C16.1466 46.4236 20.7699 47.8261 25.4995 47.8261C27.8001 47.8242 30.0881 47.4859 32.2908 46.8217L39.8169 54.3478H45.0647C45.6413 54.3478 46.1942 54.5769 46.6019 54.9846C47.0096 55.3922 47.2386 55.9452 47.2386 56.5217V61.7696L50.0495 64.5804C50.4571 64.9882 51.0099 65.2173 51.5864 65.2174H55.9343C56.5108 65.2174 57.0638 65.4464 57.4714 65.8541C57.8791 66.2618 58.1082 66.8148 58.1082 67.3913V71.7391C58.1083 72.3156 58.3374 72.8685 58.7451 73.2761L63.093 77.6239C63.5005 78.0316 64.0534 78.2607 64.6299 78.2609H77.6734C78.2499 78.2609 78.8029 78.0318 79.2106 77.6241C79.6183 77.2165 79.8473 76.6635 79.8473 76.087V63.0435C79.8472 62.467 79.6181 61.9141 79.2103 61.5065ZM20.0647 26.087C18.5598 26.087 17.0888 25.6407 15.8375 24.8047C14.5863 23.9686 13.6111 22.7803 13.0352 21.39C12.4593 19.9997 12.3086 18.4698 12.6022 16.9939C12.8958 15.5179 13.6204 14.1622 14.6845 13.0981C15.7486 12.034 17.1044 11.3094 18.5803 11.0158C20.0563 10.7222 21.5861 10.8729 22.9764 11.4488C24.3667 12.0246 25.555 12.9999 26.3911 14.2511C27.2271 15.5023 27.6734 16.9734 27.6734 18.4783C27.6734 20.4962 26.8718 22.4315 25.4449 23.8584C24.0179 25.2853 22.0826 26.087 20.0647 26.087Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2103 61.5065L74.8625 57.1587C74.4549 56.751 73.9021 56.5219 73.3256 56.5217H68.9777C68.4012 56.5217 67.8482 56.2927 67.4405 55.885C67.0329 55.4773 66.8038 54.9244 66.8038 54.3478V50C66.8037 49.4235 66.5746 48.8706 66.1669 48.463L48.4082 30.7044C49.0723 28.5017 49.4106 26.2137 49.4125 23.9131C49.4125 19.1835 48.01 14.5602 45.3824 10.6277C42.7548 6.6952 39.0201 3.6302 34.6506 1.82028C30.2811 0.0103612 25.4729 -0.463197 20.8343 0.459493C16.1956 1.38218 11.9347 3.65968 8.5904 7.00398C5.24611 10.3483 2.96861 14.6092 2.04592 19.2478C1.12323 23.8865 1.59679 28.6946 3.40671 33.0642C5.21663 37.4337 8.28162 41.1684 12.2141 43.796C16.1466 46.4236 20.7699 47.8261 25.4995 47.8261C27.8001 47.8242 30.0881 47.4859 32.2908 46.8217L39.8169 54.3478H45.0647C45.6413 54.3478 46.1942 54.5769 46.6019 54.9846C47.0096 55.3922 47.2386 55.9452 47.2386 56.5217V61.7696L50.0495 64.5804C50.4571 64.9882 51.0099 65.2173 51.5864 65.2174H55.9343C56.5108 65.2174 57.0638 65.4464 57.4714 65.8541C57.8791 66.2618 58.1082 66.8148 58.1082 67.3913V71.7391C58.1083 72.3156 58.3374 72.8685 58.7451 73.2761L63.093 77.6239C63.5005 78.0316 64.0534 78.2607 64.6299 78.2609H77.6734C78.2499 78.2609 78.8029 78.0318 79.2106 77.6241C79.6183 77.2165 79.8473 76.6635 79.8473 76.087V63.0435C79.8472 62.467 79.6181 61.9141 79.2103 61.5065ZM20.0647 26.087C18.5598 26.087 17.0888 25.6407 15.8375 24.8047C14.5863 23.9686 13.6111 22.7803 13.0352 21.39C12.4593 19.9997 12.3086 18.4698 12.6022 16.9939C12.8958 15.5179 13.6204 14.1622 14.6845 13.0981C15.7486 12.034 17.1044 11.3094 18.5803 11.0158C20.0563 10.7222 21.5861 10.8729 22.9764 11.4488C24.3667 12.0246 25.555 12.9999 26.3911 14.2511C27.2271 15.5023 27.6734 16.9734 27.6734 18.4783C27.6734 20.4962 26.8718 22.4315 25.4449 23.8584C24.0179 25.2853 22.0826 26.087 20.0647 26.087Z",
    fill: "url(#paint7_linear_16_129)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3618 62.3551L78.3619 62.3552C78.5445 62.5377 78.6472 62.7853 78.6473 63.0435C78.6473 63.0436 78.6473 63.0437 78.6473 63.0437V76.087C78.6473 76.3453 78.5447 76.593 78.362 76.7756C78.1794 76.9583 77.9317 77.0609 77.6734 77.0609H64.6302C64.6301 77.0609 64.63 77.0609 64.6299 77.0609C64.3717 77.0607 64.1241 76.9581 63.9416 76.7755L63.9415 76.7754L59.5937 72.4276L59.5935 72.4274C59.4109 72.2449 59.3083 71.9973 59.3082 71.7391C59.3082 71.739 59.3082 71.739 59.3082 71.7389V67.3913C59.3082 66.4965 58.9527 65.6383 58.32 65.0056C57.6872 64.3729 56.8291 64.0174 55.9343 64.0174H51.5867C51.5866 64.0174 51.5865 64.0174 51.5864 64.0174C51.3282 64.0173 51.0807 63.9146 50.8981 63.732L50.898 63.7319L48.4386 61.2725V56.5217C48.4386 55.6269 48.0831 54.7688 47.4504 54.136C46.8177 53.5033 45.9595 53.1478 45.0647 53.1478H40.3139L33.1393 45.9732L32.6317 45.4656L31.9444 45.6728C29.8537 46.3032 27.6821 46.6243 25.4985 46.6261C21.0066 46.6259 16.6157 45.2938 12.8808 42.7983C9.14565 40.3025 6.23446 36.7552 4.51536 32.605C2.79627 28.4547 2.34647 23.8879 3.22286 19.482C4.09925 15.0761 6.26246 11.029 9.43893 7.85251C12.6154 4.67603 16.6625 2.51282 21.0684 1.63644C25.4743 0.760048 30.0411 1.20984 34.1914 2.92894C38.3416 4.64803 41.8889 7.55922 44.3847 11.2944C46.8802 15.0292 48.2123 19.4202 48.2125 23.9121C48.2107 26.0957 47.8896 28.2673 47.2593 30.358L47.052 31.0453L47.5596 31.5529L65.3183 49.3116L65.3185 49.3117C65.5011 49.4942 65.6037 49.7418 65.6038 50C65.6038 50.0001 65.6038 50.0002 65.6038 50.0003V54.3478C65.6038 55.2426 65.9593 56.1008 66.592 56.7336C67.2247 57.3663 68.0829 57.7217 68.9777 57.7217H73.3253C73.3254 57.7217 73.3255 57.7217 73.3256 57.7217C73.5837 57.7219 73.8313 57.8245 74.0139 58.0071L74.014 58.0072L78.3618 62.3551ZM15.1708 25.8024C16.6194 26.7703 18.3225 27.287 20.0647 27.287C22.4009 27.287 24.6414 26.3589 26.2934 24.707C27.9453 23.055 28.8734 20.8145 28.8734 18.4783C28.8734 16.7361 28.3568 15.033 27.3889 13.5844C26.4209 12.1358 25.0452 11.0068 23.4356 10.3401C21.8261 9.67339 20.0549 9.49895 18.3462 9.83883C16.6375 10.1787 15.0679 11.0177 13.836 12.2496C12.6041 13.4815 11.7651 15.0511 11.4253 16.7598C11.0854 18.4685 11.2598 20.2396 11.9265 21.8492C12.5932 23.4588 13.7223 24.8345 15.1708 25.8024Z",
    stroke: "url(#paint8_linear_16_129)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_16_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6722 78.2619C77.0957 78.2618 76.5429 78.0327 76.1353 77.625L41.3527 42.8424C40.9567 42.4324 40.7376 41.8832 40.7425 41.3132C40.7475 40.7432 40.9761 40.198 41.3792 39.7949C41.7822 39.3919 42.3275 39.1632 42.8975 39.1583C43.4674 39.1533 44.0166 39.3725 44.4266 39.7684L79.2092 74.5511C79.5131 74.8551 79.7201 75.2424 79.8039 75.664C79.8878 76.0857 79.8447 76.5227 79.6802 76.9199C79.5157 77.317 79.2372 77.6565 78.8798 77.8954C78.5223 78.1343 78.1021 78.2618 77.6722 78.2619Z",
    fill: "white",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_16_129",
    x: 51.5864,
    y: 26.1152,
    width: 34.7559,
    height: 31.1907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_129"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_16_129",
    x: 68.9778,
    y: 60.8691,
    width: 23.9131,
    height: 42.0869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_129"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_16_129",
    x: 38.543,
    y: 50,
    width: 14.9539,
    height: 54.8674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_129"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bi_16_129",
    x: -46.4136,
    y: -48,
    width: 174.261,
    height: 174.261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_129",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_129"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_16_129",
    x: 40.7424,
    y: 39.1582,
    width: 39.1032,
    height: 55.1038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_129",
    x1: 40.7424,
    y1: 39.1582,
    x2: 86.8049,
    y2: 50.8542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_129",
    x1: 47.2385,
    y1: 82.6094,
    x2: 67.7249,
    y2: 87.8113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_129",
    x1: 82.0212,
    y1: 82.6094,
    x2: 102.508,
    y2: 87.8113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_129",
    x1: 77.6733,
    y1: 17.3906,
    x2: 98.1598,
    y2: 22.5925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16_129",
    x1: 52.6725,
    y1: 26.8057,
    x2: 86.3423,
    y2: 26.8057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16_129",
    x1: 69.7251,
    y1: 62.0549,
    x2: 92.8908,
    y2: 62.0549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16_129",
    x1: 39.0103,
    y1: 51.7667,
    x2: 53.4968,
    y2: 51.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16_129",
    x1: 1.58643,
    y1: 0,
    x2: 93.7753,
    y2: 23.4085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16_129",
    x1: 4.03208,
    y1: 3.55731,
    x2: 79.8473,
    y2: 3.55731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseKey);
export default __webpack_public_path__ + "static/media/license_key.680ec2779dd72b86c1983355e664fe41.svg";
export { ForwardRef as ReactComponent };